import React from "react";
import { Breadcrumbs, Button } from "@material-ui/core";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { MENU_LIQUIDACIONES } from "../../utils/constants";
import { LIQUIDACIONES_MENU_PERMISOS } from "../../utils/permisos";
import { CloudUploadSharp, ReceiptSharp } from "@material-ui/icons";

const style = {
  root: {
    flexGrow: 1,
  },
};

export const LiquidacionesBreadcrumb = ({ setActiveBreadcrumb, activeBreadcrumb,
  validarSoloUnPermiso, permisosUser }) => {

  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      {validarSoloUnPermiso(
        permisosUser,
        LIQUIDACIONES_MENU_PERMISOS.GESTION_FACTURAS
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_LIQUIDACIONES.GESTION_FACTURAS
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_LIQUIDACIONES.GESTION_FACTURAS);
            }}
          >
            <AccountBalanceIcon className={style.icon} />
            Gestion de Facturas
          </Button>
        )}
      {validarSoloUnPermiso(
        permisosUser,
        LIQUIDACIONES_MENU_PERMISOS.GESTION_FACTURAS
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_LIQUIDACIONES.CARGA_ARCHIVO_HELIOS
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_LIQUIDACIONES.CARGA_ARCHIVO_HELIOS);
            }}
          >
            <CloudUploadSharp className={style.icon} />
            Carga Archivo Helios
          </Button>
        )}
      {validarSoloUnPermiso(
        permisosUser,
        LIQUIDACIONES_MENU_PERMISOS.GESTION_FACTURAS
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_LIQUIDACIONES.CARGA_ARCHIVO_SCIENZA
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_LIQUIDACIONES.CARGA_ARCHIVO_SCIENZA);
            }}
          >
            <CloudUploadSharp className={style.icon} />
            Carga Archivo Scienza
          </Button>
        )}
      {validarSoloUnPermiso(
        permisosUser,
        LIQUIDACIONES_MENU_PERMISOS.GESTION_FACTURAS
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_LIQUIDACIONES.GENERACION_VOUCHERS
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_LIQUIDACIONES.GENERACION_VOUCHERS);
            }}
          >
            <ReceiptSharp className={style.icon} />
            Generar Vouchers
          </Button>
        )}
      {validarSoloUnPermiso(
        permisosUser,
        LIQUIDACIONES_MENU_PERMISOS.GESTION_FACTURAS
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_LIQUIDACIONES.CONSULTA_EXPEDIENTES
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_LIQUIDACIONES.CONSULTA_EXPEDIENTES);
            }}
          >
            <AccountBalanceIcon className={style.icon} />
            Consulta Expedientes
          </Button>
        )}

      {/* validarSoloUnPermiso(
          permisosUser,
          AUTORIZACIONES_MENU_PERMISOS.GESTION_AUDITORIA
        ) && (
          <Button
            color={
              activeBreadcrumb === MENU_AUTORIZACIONES.GESTION_AUDITORIA
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_AUTORIZACIONES.GESTION_AUDITORIA);
            }}
          >
            <Search className={style.icon} />
            Gestión de Auditoria
          </Button>
      )*/}
      {/* validarSoloUnPermiso(
          permisosUser,
          AUTORIZACIONES_MENU_PERMISOS.GESTION_PRESUPUESTOS
        ) && (
          <Button
            color={
              activeBreadcrumb === MENU_AUTORIZACIONES.GESTION_PRESUPUESTOS
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_AUTORIZACIONES.GESTION_PRESUPUESTOS);
            }}
          >
            <Search className={style.icon} />
            Gestión de Presupuestos
          </Button>
      )*/}
      {/* validarSoloUnPermiso(
          permisosUser,
          AUTORIZACIONES_MENU_PERMISOS.SOLICITUDES_VIA_APP
        ) && (
          <Button
            color={
              activeBreadcrumb === MENU_AUTORIZACIONES.SOLICITUDES_VIA_APP
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              setActiveBreadcrumb(MENU_AUTORIZACIONES.SOLICITUDES_VIA_APP);
            }}
          >
            <Search className={style.icon} />
            Solicitudes via APP
          </Button>
      )*/}
    </Breadcrumbs>
  );
};
